import type { MondayService } from "./monday-service";
import { mondayService } from "./monday-service";
import type { EnsureOAuthTokenFunc } from "./oauth-service";
import { ensureOAuthToken } from "./oauth-service";
import { cliService } from "./runcli-service";

export interface ServicesConfig {
  mondayService: MondayService;
  oauthService: EnsureOAuthTokenFunc;
}

export function servicesConfig() {
  return {
    mondayService: mondayService,
    cliService: cliService,
    oauthService: ensureOAuthToken,
  };
}
